import { Component, Inject, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RoutingService } from './shared/services/routing.service';
import { ConfigService } from './shared/services/config.service';
import { AppService } from './shared/services/app.service';
import { PublicNavigationComponent } from './modules/public/components/layout/public-navigation/public-navigation.component';
import { ServerConfig } from './shared/models/config.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { ResponsiveService } from './shared/services/responsive.service';
import { FooterComponent } from './shared/components/footer/footer.component';
import { DefaultService } from './utils/api';
import { PopupComponent } from './shared/components/popup/popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieBannerComponent } from './modules/public/components/modals/cookie-banner/cookie-banner.component';
import { NavigationService } from './shared/services/navigation.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        PublicNavigationComponent,
        PublicNavigationComponent,
        FooterComponent,
        CookieBannerComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    configService = inject(ConfigService);
    appService = inject(AppService);
    routingService = inject(RoutingService);
    navigationService = inject(NavigationService);
    responsiveService = inject(ResponsiveService);
    defaultService = inject(DefaultService);
    modalService = inject(NgbModal);

    ready: boolean = false;
    version: string;
    screenSize = toSignal(this.responsiveService.onResize$, {
        initialValue: this.responsiveService.getScreenSize(window.innerWidth)
    });
    // pages: Page[];

    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(@Inject('config') private config: ServerConfig) {}

    async ngOnInit() {
        this.appService.setLanguage();
        this.configService.serverConfig.set(this.config);
        this.version = this.appService.getVersion();
        await this.routingService.init();
        await this.navigationService.initNavigation();
        this.ready = true;

        this.getPopup();
    }

    getPopup() {
        this.defaultService.popupGetPopup().subscribe((next) => {
            // if (next?.data) {
            const storedHash = localStorage.getItem('dismissedPopup');
            const exist = next?.data && Object.keys(next?.data) ? !!Object.keys(next?.data)?.length : false;
            if (exist) {
                const popupHash = this.generatePopupHash(next?.data);
                if (storedHash !== popupHash) {
                    const modalRef = this.modalService.open(PopupComponent, {
                        size: 'lg',
                        beforeDismiss: () => {
                            return true;
                        }
                    });
                    modalRef.componentInstance.popup = next?.data;
                    localStorage.setItem('dismissedPopup', popupHash);
                }
            } else {
                localStorage.removeItem('dismissedPopup');
            }
        });
    }

    generatePopupHash(popup): string {
        return btoa(JSON.stringify(popup));
    }
}
